export default __webpack_public_path__ + "static/media/landing_slider_3.90debba8.jpg";